import "regenerator-runtime/runtime";
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { getApi, postApi, deleteApi, putApi, downloadApi } from './../api/api';
import { setGlobalParam } from './../reducers/reducers';
import { toast } from 'react-toastify';
import { history } from './../store';

import {
    getEverySaga,
    getLatestSaga,
    postEverySaga,
    postLatestSaga,
    delEverySaga,
    delLatestSaga,
    putEverySaga,
    putLatestSaga,
    downLatestSaga
} from "../actions/actions";
const component = 'sagas.js';
export const sagas = [
    takeEvery(postEverySaga, postFunction),
    takeLatest(postLatestSaga, postFunction),
    takeEvery(getEverySaga, getFunction),
    takeLatest(getLatestSaga, getFunction),
    takeEvery(delEverySaga, delFunction),
    takeLatest(delLatestSaga, delFunction),
    takeEvery(putEverySaga, putFunction),
    takeLatest(putLatestSaga, putFunction),
    takeLatest(downLatestSaga, downFunction),
];

function* getFunction({ api, headers, storage, nextRoute, showLoadingStorage, errorStorage, isAlert, successAlert, errorAlert }) {
    try {
        // function to make loading state true
        if (showLoadingStorage != null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: true, component: component });
        }
        // function to call API
        const response = yield call(getApi, api, headers);

        // // if token already expired
        // if (typeof response.data !== 'undefined') {
        //     if (response.data.token == false) {
        //         yield call(tokenInvalid, response.message);
        //         return;
        //     }
        // }

        //if code have error from backend
        if (response.responseParams.errorMessage) {
            toast.error(response.responseParams.errorMessage);
            yield call(history.goBack());
        }

        // yield put({ type: setGlobalParam, storage: storage, response: response.data });
        if (response.success === true) {
            //if have pass storage the store at reducer
            if (storage != null) {
                yield put({ type: setGlobalParam, storage: storage, response: response.responseParams });
            }

            if (successAlert != null) {
                //will show success toast message from frontend
                toast.success(successAlert);
            }

            if (isAlert) {
                //will show success toast message from backend
                toast.success(response.message)
            }
        } else {
            //if error from backend
            if (errorStorage) {
                yield put({ type: setGlobalParam, storage: errorStorage, response: response.responseParams, component: component });
            }
            toast.error(response.message)
        }
        //set show loading to false
        if (showLoadingStorage != null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: false, component: component });
        }
    } catch (error) {
        console.log(error);
    }
}

function* postFunction({ api, headers, storage, nextRoute, data, showLoadingStorage, errorStorage, isAlert, successAlert, errorAlert }) {
    try {
        // function to make loading state true
        if (showLoadingStorage !== null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: true, component: component });
        }
        // function to call API
        const response = yield call(postApi, api, data, headers);
        //if code have error from backend
        if (response.responseParams.errorMessage) {
            toast.error(response.responseParams.errorMessage);
            yield call(history.goBack());
        }

        if (response.success == true) {
            if (storage !== null) {
                yield put({ type: setGlobalParam, storage: storage, response: response.responseParams, component: component });
            }

            if (successAlert != null) {
                //will show success toast message from frontend
                toast.success(successAlert);
            }

            if (isAlert) {
                //will show success toast message from backend
                toast.success(response.message)
            }

            if (nextRoute != null) {
                yield call(history.push(nextRoute));
            }
        } else {
            //if error from backend
            if (errorStorage) {
                yield put({ type: setGlobalParam, storage: errorStorage, response: response.responseParams, component: component });
            }
            toast.error(response.message)
        }

        // function to make loading state false
        if (showLoadingStorage != null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: false, component: component });
        }
    } catch (error) {
        console.log(error);
    }
}

function* putFunction({ api, headers, storage, nextRoute, data, showLoadingStorage, errorStorage, isAlert }) {
    try {
        if (showLoadingStorage != null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: true, component: component });
        }
        const response = yield call(putApi, api, data, headers);

        if (response.success == true) {
            if (storage != null) {
                yield put({ type: setGlobalParam, storage: storage, response: response.data, component: component });
            }

            if (isAlert) {
                toast.success(response.message)
            }
        } else {
            //if error from backend
            if (errorStorage) {
                yield put({ type: setGlobalParam, storage: errorStorage, response: response.data, component: component });
            }
            toast.error(response.message)
        }

        if (showLoadingStorage != null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: false, component: component });
        }

    } catch (error) {
        console.log(error);
    }
}

function* delFunction({ api, storage, nextRoute, showLoadingStorage, isAlert }) {
    try {
        if (showLoadingStorage !== null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: true, component: component });
        }
        const response = yield call(deleteApi, api);
        if (showLoadingStorage !== null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: false, component: component });
        }

        // if token already expired
        if (typeof response.data !== 'undefined') {
            if (response.data.token === false) {
                yield call(tokenInvalid, response.message);
                return;
            }
        }

        if (response.success == true) {
            if (storage != null) {
                yield put({ type: setGlobalParam, storage: storage, response: response.data, component: component });
            }

            if (isAlert) {
                toast.success(response.message)
            }
        } else {
            //if error from backend
            toast.error(response.message)
        }

    } catch (error) {
        console.log(error);
    }
}

function* downFunction({ api, storage, nextRoute, showLoadingStorage, downloadTimestampStorage, errorStorage, isAlert, fileName }) {
    try {
        if (showLoadingStorage != null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: true, component: component });
        }

        // const response = yield call(downloadApi, api, fileName);

        if (downloadTimestampStorage != null) {
            yield put({ type: setGlobalParam, storage: downloadTimestampStorage, response: Date.now(), component: component });
        }

        //set show loading to false
        if (showLoadingStorage != null) {
            yield put({ type: setGlobalParam, storage: showLoadingStorage, response: false, component: component });
        }
    } catch (error) {
        console.log(error);
    }
}


function* tokenInvalid(message) {
    yield put({ type: setGlobalParam, storage: 'is_authenticated', response: false, component: component });
    localStorage.removeItem('token');
    yield call(history.push, '/login');
    toast.error(message)
}







// WEBPACK FOOTER //
// ./src/sagas/sagas.js